/* This is generated code, don't alter */
var IfcInventoryTypeEnum;
(function (IfcInventoryTypeEnum) {
    IfcInventoryTypeEnum[IfcInventoryTypeEnum["ASSETINVENTORY"] = 0] = "ASSETINVENTORY";
    IfcInventoryTypeEnum[IfcInventoryTypeEnum["SPACEINVENTORY"] = 1] = "SPACEINVENTORY";
    IfcInventoryTypeEnum[IfcInventoryTypeEnum["FURNITUREINVENTORY"] = 2] = "FURNITUREINVENTORY";
    IfcInventoryTypeEnum[IfcInventoryTypeEnum["USERDEFINED"] = 3] = "USERDEFINED";
    IfcInventoryTypeEnum[IfcInventoryTypeEnum["NOTDEFINED"] = 4] = "NOTDEFINED";
})(IfcInventoryTypeEnum || (IfcInventoryTypeEnum = {}));
const IfcInventoryTypeEnumCount = 5;
export { IfcInventoryTypeEnum, IfcInventoryTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcInventoryTypeEnum = new Int32Array([35]);
let prefixSumAddressIfcInventoryTypeEnum = new Uint32Array([0, 16, 36, 49, 61, 77]);
let slotMapIfcInventoryTypeEnum = new Int32Array([1, 2, 3, 4, 0]);
let encodedDataIfcInventoryTypeEnum = (new TextEncoder()).encode(".SPACEINVENTORY..FURNITUREINVENTORY..USERDEFINED..NOTDEFINED..ASSETINVENTORY.");
let IfcInventoryTypeEnumSearch = new MinimalPerfectHash(gMapIfcInventoryTypeEnum, prefixSumAddressIfcInventoryTypeEnum, slotMapIfcInventoryTypeEnum, encodedDataIfcInventoryTypeEnum);
export { IfcInventoryTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcInventoryTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcInventoryTypeEnumSearch, input, cursor, endCursor);
}
